
export const EventsSignIn = {
    1: "cl_lnd_st1_sign", 2: "cl_lnd_st2_sign", 3: "cl_lnd_st3_sign", 4: "cl_lnd_st4_sign", 5: "cl_lnd_st5_sign"
}

export const EventsErrorName = {
    "Please enter your name": "err_lnd_name_noname",
    "Your name should have at least 2 letters": "err_lnd_name_shortname",
    "Only letters (A-z, a-z) are allowed": "err_lnd_name_symbolname"
}

export const errorEventsBirthday = {
    "": "err_lnd_age_nodate",
    M: "err_lnd_age_onlymonth",
    D: "err_lnd_age_onlyday",
    Y: "err_lnd_age_onlyyear",
    MD: "err_lnd_age_onlydaymonth",
    DY: "err_lnd_age_onlydayyear",
    MY: "err_lnd_age_onlymonthyear",
};

export const errorEventsEmail = {
    "Please enter your email": "err_lnd_email_noemail",
    "Please enter a valid email": "err_lnd_email_wrongemail",
};

export const ERROR_EMAIL_ALREADY_USED =
    "This email address has already been used.";

export const ERROR_EMAIL_ALREADY_REGISTERED =
    "This email is already registered";

export const ERROR_EMAIL_INVALID = "Please enter a valid email address.";

export const ERROR_NOT_VALID_EMAIL = "Please enter a valid email";

export const errorEventsPassword = {
    empty: "err_lnd_password_nopassword",
    too_short: "err_lnd_password_shortpassword",
};

export const domains = [
    "@gmail.com",
    "@yahoo.com",
    "@hotmail.com",
    "@aol.com",
    "@outlook.com",
    "@comcast.net",
    "@live.com",
    "@mail.com",
    "@msn.com",
    "@att.net",
    "@icloud.com",
];
export const landingId = "3025687cb01f21af6775b6b3522f3519";

